module.exports = __webpack_public_path__ + "static/floral 3 3000x3000-8d0be916b85ac228a5fa12c675483c50.jpg";